import React from 'react';
import {useStores} from "../../../stores/Context";
import FlecheRevenirSvg from "../../../boiteAOutils/SVG/FlecheRevenirSvg";

const WidgetIndicateursBtn = () => {
    const { uiStore} = useStores();

    const handleBackHome = () => {
        uiStore.closeConsultingMode();
    }

    return (
        <div className={"navBarWidgetBtnContent"}>
            <div className={"widgetsNavBarContentIcons"} onClick={() => handleBackHome("Lecture")}>
                <FlecheRevenirSvg width={40} height={40} couleur={"#FBFDFE"}/>
                <span className={"widgetsNavBarContentIconsText"}>Revenir</span>
            </div>

        </div>
    );
};

export default WidgetIndicateursBtn;